module.exports = __webpack_public_path__ + "static/media/delete.50bd7708.svg";